module.exports = __webpack_public_path__ + "img/ico_tag.ae595d4.png";